import { render, staticRenderFns } from "./ArticleCoverMedia.vue?vue&type=template&id=7a736a77&scoped=true&"
import script from "./ArticleCoverMedia.vue?vue&type=script&lang=js&"
export * from "./ArticleCoverMedia.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCoverMedia.vue?vue&type=style&index=0&id=7a736a77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a736a77",
  null
  
)

export default component.exports